import React, { useEffect, useMemo, useState } from "react";
import KapalService from "../../../../services/kapal/KapalService";
import UserService from "../../../../services/user/UserService";
import { Button, Modal, Spinner } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalAddTimTeknis = ({ showAddTim, handleCloseAddTim, dataPpmKapal, dataDisposisi, reloadList, isEdit }) => {
    let kapalService = useMemo(() => new KapalService(), []);
    let userService = useMemo(() => new UserService(), []);
    const [idInspeksi, setIdInspeksi] = useState(null)

    useEffect(() => {
        if (!dataPpmKapal) return;
        const fetchAllData = async () => {
            try {
                const resDataInspeksi = await kapalService.getInspeksiData(dataPpmKapal.nomorAjuKapal);
                if (!resDataInspeksi?.data) return;
                const idInspeksi = resDataInspeksi.data.idInspeksi;
                setIdInspeksi(idInspeksi);
            } catch (error) {
                console.log(error)
            }
        }
        fetchAllData();
    }, [kapalService, dataPpmKapal]);

    const [valuePegawaiOpt, setValuePegawaiOpt] = useState(null)
    const [valuePegawaiOptPusat, setValuePegawaiOptPusat] = useState(null)
    const [valuePejabatOpt, setValuePejabatOpt] = useState(null)

    async function loadOptionPegawai(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawaiOpt = e => {
        setValuePegawaiOpt(e)
    }

    async function loadOptionPegawaiPusat(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, "00.3", page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePegawaiOptPusat = e => {
        setValuePegawaiOptPusat(e)
    }

    async function loadOptionPejabatTtd(search, loadedOption, { page = 1 }) {
        const response = await userService.listPegawai(search, localStorage.getItem('kdUnit'), page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }
    const onChangePejabatOpt = e => {
        setValuePejabatOpt(e)
    }


    const [showConfirmPenugasan, setShowConfirmPenugasan] = useState(false)
    const handleCloseConfirmPenugasan = () => setShowConfirmPenugasan(false)
    const [showPenugasanSuccess, setShowPenugasanSuccess] = useState(false)
    const [showPenugasanFailed, setShowPenugasanFailed] = useState(false)
    const [loadingSave, setLoadingSave] = useState(false)
    const [rowPenugasan, setRowPenugasan] = useState(null)

    const SavePenugasan = (dataDisposisi) => {
        setShowConfirmPenugasan(true)
        setRowPenugasan(dataDisposisi)
    }

    const handleClickPenugasan = async () => {
        setLoadingSave(true)
        try {
            let jsonPenugasan = { ...rowPenugasan, noTugas: 'EVT-' + dataPpmKapal.nomorAjuKapal, tglTugas: new Date(), nipPejabat: valuePejabatOpt.nip, nmPejabat: valuePejabatOpt.nama, createdBy: localStorage.getItem("userId"), createdAt: new Date() }
            const _resSpp = await kapalService.savePenugasan(jsonPenugasan)
            if (_resSpp.data.kode === '200') {
                valuePegawaiOpt.map(async (pegawai) => {
                    let newJson = {
                        nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                        nipEvaluator: pegawai.nip,
                        nmEvaluator: pegawai.nama,
                        idInspeksi: idInspeksi,
                        createdBy: localStorage.getItem('userId'),
                        createdDate: new Date()
                    }
                    await kapalService.saveEvaluasiTeknis(newJson)
                })
                let jsonPusat = {
                    nomorAjuKapal: dataPpmKapal.nomorAjuKapal,
                    nipEvaluator: valuePegawaiOptPusat.nip,
                    nmEvaluator: valuePegawaiOptPusat.nama,
                    idInspeksi: idInspeksi,
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date()
                }
                await kapalService.saveEvaluasiTeknis(jsonPusat)
                setShowPenugasanSuccess(true)
                setShowConfirmPenugasan(false)
            }
        } catch (error) {
            console.log(error)
            setShowPenugasanFailed(true)
        }
        setLoadingSave(false)
    }

    const handleClickPenugasanSuccess = () => {
        setShowPenugasanSuccess(false)
        // window.location.reload()
        reloadList(0, 10, dataPpmKapal.nomorAjuKapal)
    }

    const handleClickPenugasanFailed = () => {
        setShowPenugasanFailed(false)
    }

    return (
        <>
            <Modal
                show={showAddTim}
                onHide={handleCloseAddTim}
                size="lg"
                centered
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title><h6>Pilih Evaluator Teknis</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tim Teknis UPT</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawai}
                                value={valuePegawaiOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOpt}
                                isMulti
                                isDisabled={!isEdit}
                                isOptionDisabled={() => valuePegawaiOpt && valuePegawaiOpt.length >= 2}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tim Teknis Pusat</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPegawaiPusat}
                                value={valuePegawaiOptPusat}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePegawaiOptPusat}
                                isDisabled={!isEdit}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Kepala UPT</label>
                        <div className="col-sm-8">
                            <AsyncPaginate
                                loadOptions={loadOptionPejabatTtd}
                                value={valuePejabatOpt}
                                getOptionLabel={(option) => option.nip + ' - ' + option.nama}
                                getOptionValue={(option) => option.nip}
                                additional={{
                                    page: 1
                                }}
                                onChange={onChangePejabatOpt}
                                isDisabled={!isEdit}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && (localStorage.getItem("role") === "7" || localStorage.getItem("role") === "2" || localStorage.getItem("role") === "3") &&
                        <Button variant="primary" size="sm" onClick={() => SavePenugasan(dataDisposisi)}>Proses</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddTim}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmPenugasan &&
                <SweetAlert
                    title="Proses Penugasan?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Proses"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickPenugasan}
                    onCancel={handleCloseConfirmPenugasan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showPenugasanSuccess &&
                <SweetAlert
                    title="Penugasan Berhasil"
                    success
                    onConfirm={handleClickPenugasanSuccess}
                    btnSize="sm"
                />
            }
            {
                showPenugasanFailed &&
                <SweetAlert
                    title="Penugasan Gagal"
                    danger
                    onConfirm={handleClickPenugasanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    );
}

export default ModalAddTimTeknis;